<template>
    <div>
        <div v-if="previewLista" class="row m-3">
            <h5>Asunto: {{ current.asunto }}</h5>
            <div class="col-sm-12 mb-3 table-responsive">
                <iframe :srcdoc="current.cuerpo" width="500" height="400"></iframe>
            </div>
            <p><span>Archivos adjuntos:</span></p>
            <div v-if="!archivosCargados">
                <p>No hay archivos disponibles.</p>
            </div>
            <div v-for="archivo in archivos" class="col-sm-12 table-responsive">
                <iframe :src="archivo.archivo" width="500" height="400"></iframe>
            </div>
        </div>
        <div v-else>
            <p>No hay información disponible.</p>
        </div>
    </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";

export default{
    
    components:{
        DynamicService,
    },
    props:["obj_id","operativo","tienda"],
    data() {
        return {
            current: null,
            archivos: null,
            baseApiUrl: process.env.VUE_APP_ROOT_API,
            correoCargado:false,
            archivosCargados:false,
        };
    },
    computed:{
        previewLista(){
            return this.correoCargado && this.archivosCargados
        }
    },
    watch: {
        previewLista(nuevoValor) {
      this.$emit('preview-cargada', nuevoValor);
    }
  },
    mounted() {
        let self = this;
        self.refreshCurrent();
    },
    methods: {
        refreshCurrent(){
            let self = this;
            self.correoCargado = false;
            let params = {
                id: self.obj_id,
                operativo: self.operativo,
                tienda: self.tienda,
            };
            DynamicService.postActionList(
                "correos","correos-enviados","obtener_por_identificador",params
            ).then(response =>{
                self.current = response.data;
                self.correoCargado = true;
                self.refreshArchivos();
            }).catch(error =>{
                self.correoCargado = false;
                if(error.response.data){
                    console.error(err.response.data);
                }
            })
        },
        refreshArchivos(){
            // Refresca los archivos adjuntos del correo actual
            let self = this;
            let params = {
                correo_enviado: self.current.id,
            };
            self.archivosCargados = false;
            DynamicService.fetch(
                "correos","correo-archivos-adjuntos",params
            ).then(response =>{
                self.archivos = response.data.results;
                self.archivosCargados = true;
            }).catch(error =>{
                self.archivosCargados = false;
                if(error.response.data){
                    console.error(error.response.data);
                }
            })
        }
    },
};
</script>